import React from "react";
import { AlertCircle } from "lucide-react";

import Template from "src/components/app/smart-cale/Template";

type ErrorStepProps = {
  error?: string | null;
};

const ErrorStep: React.FC<ErrorStepProps> = ({ error }) => {
  return (
    <Template
      title="Connection Failed"
      titleClassName="text-xl font-bold text-center mt-6 text-red-500"
      description={
        <p className="text-center text-gray-600 mt-2 mb-8">
          {error ??
            "Unable to connect to the CGM Reader. Please ensure the device is nearby and try again."}
        </p>
      }
      image={
        <div className="w-24 h-24 rounded-full bg-red-50 flex items-center justify-center">
          <AlertCircle className="w-12 h-12 text-red-500" />
        </div>
      }
    />
  );
};

export default ErrorStep;

